export default "__VITE_ASSET__fzKDrnJu__"